import { render, staticRenderFns } from "./wangEditor.vue?vue&type=template&id=5cd25411&lang=html&"
import script from "./wangEditor.vue?vue&type=script&lang=js&"
export * from "./wangEditor.vue?vue&type=script&lang=js&"
import style0 from "./wangEditor.vue?vue&type=style&index=0&id=5cd25411&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports